import React from 'react';
import { Create, Datagrid, Edit, EditButton, List, Show, ShowButton, SimpleForm, SimpleShowLayout } from 'react-admin';
import { ListActions } from '../../components/List';
import CustomPagination from '../../components/Pagination';
import { fieldsToInputs, resourcesPropertiesToFields } from "../../helpers/fieldTransformer";

export const RecommendationChapterList = (props) => {
  const { options: { api, resource } } = props;
  const fields = resourcesPropertiesToFields(api, resource);

  return (
    <List
      {...props}
      bulkActionButtons={false}
      exporter={false}
      pagination={<CustomPagination />}
      perPage={50} actions={<ListActions />}
    >
      <Datagrid>
        {fields.map(field =>
          field
        )}
        <EditButton basePath="/recommendation_chapters" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export const RecommendationChapterCreate = (props) => {
  const { options: { api, resource } } = props;

  const fields = fieldsToInputs(api, resource);

  return (
    <Create {...props}>
      <SimpleForm>
        {fields.map(field =>
          field
        )}
      </SimpleForm>
    </Create>
  )
};

export const RecommendationChapterEdit = (props) => {
  const { options: { api, resource } } = props;

  const fields = fieldsToInputs(api, resource);

  return (
    <Edit {...props}>
      <SimpleForm>
        {fields.map(field =>
          field
        )}
      </SimpleForm>
    </Edit>
  )
};

export const RecommendationChapterShow = (props) => {
  const { options: { api, resource } } = props;
  const fields = resourcesPropertiesToFields(api, resource);

  return (
    <Show {...props}>
      <SimpleShowLayout>
        {fields.map(field =>
          field
        )}
      </SimpleShowLayout>
    </Show>
  )
};
